import React, { useState } from "react";
import { signIn, signUp } from "./chatService";

export default function ChatLogin() {
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      if (mode === "login") {
        await signIn({ name: name.trim(), email: email.trim(), password });
      } else {
        await signUp({
          name: name.trim(),
          email: email.trim(),
          password,
        });
      }
    } catch (err) {
      setError(prettyAuthError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="chat-auth-screen">
      <form className="chat-auth-card" onSubmit={onSubmit}>
        <h1>💬 Chat</h1>
        <p className="chat-muted">
          {mode === "login" ? "Sign in to your account." : "Create an account."}
        </p>

        <label>
          Name
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="username"
            placeholder="Your name"
            required
            minLength={3}
            maxLength={80}
            autoFocus
          />
        </label>

        <label>
          Email
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            placeholder="you@example.com"
            required={mode === "signup"}
            maxLength={120}
          />
        </label>

        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === "login" ? "current-password" : "new-password"}
            required
            minLength={6}
          />
        </label>

        {error && <div className="chat-auth-error">{error}</div>}

        <button type="submit" className="chat-btn-primary" disabled={busy}>
          {busy ? "…" : mode === "login" ? "Sign in" : "Create account"}
        </button>

        <button
          type="button"
          className="chat-btn-link"
          onClick={() => { setMode(mode === "login" ? "signup" : "login"); setError(null); }}
        >
          {mode === "login" ? "Need an account? Sign up" : "Have an account? Sign in"}
        </button>
      </form>
    </div>
  );
}

// Translate Firebase auth/* error codes into something a normal human can read.
function prettyAuthError(err) {
  const code = err && err.code;
  switch (code) {
    case "auth/invalid-email": return "That email doesn't look right.";
    case "auth/missing-password":
    case "auth/weak-password": return "Password must be at least 6 characters.";
    case "auth/email-already-in-use": return "That email is already registered. Try signing in.";
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found": return "Wrong email/name or password.";
    case "auth/too-many-requests": return "Too many tries. Wait a minute and try again.";
    case "auth/operation-not-allowed":
      return "Email/password sign-in isn't enabled in the Firebase console yet.";
    case "auth/network-request-failed":
      return "Network problem. Check your connection.";
    default: return (err && err.message) || "Couldn't sign in.";
  }
}
